import { HeadCell } from '../../../../component/table/interfaces/TableInterface';

export const HEAD_CELL: Array<HeadCell> = [
  { id: 'local', label: 'Bandeira | Regional | Loja' },
  { id: 'user_ad', label: 'Usuário AD' },
  { id: 'user_phone', label: 'Telefone' },
  { id: 'action', label: 'Ação' },
  { id: 'state', label: 'Situação' },
  { id: 'origin', label: 'Origem' },
  { id: 'created_at', label: 'Criado em' },
];
